module.exports = __webpack_public_path__ + "media/images/icons/Strakonice_web_ikony/hlukovaMapa@3x-6051b3d2d2af6e2f4031deeb7934c6cf.png";